import React from "react";
import { observer } from "mobx-react";
import { Nav } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";

@observer
export class ReportsLayout extends React.Component<any, any> {
    render() {
        return <div>
            <Nav variant="tabs" defaultActiveKey="/reports/report1">
                <LinkContainer to="/reports/report1">
                    <Nav.Item>
                        <Nav.Link href="/reports/report1">Отчет продаж по мененджерам</Nav.Link>
                    </Nav.Item>
                </LinkContainer>
                <LinkContainer to="/reports/report2">
                    <Nav.Item>
                        <Nav.Link href="/reports/report2">Отчет продаж абтеки</Nav.Link>
                    </Nav.Item>
                </LinkContainer>
                <LinkContainer to="/reports/report3">
                    <Nav.Item>
                        <Nav.Link href="/reports/report3">Отчет продаж по клиентам</Nav.Link>
                    </Nav.Item>
                </LinkContainer>
            </Nav>

            <div>
                {this.props.children}
            </div>
        </div>;
    }
}